import { Community } from "types";
import axiosApi from './config';

const communityApi = {
  getCommunityById(id: string): Promise<Community> {
    const url = `api/onboarding/community/${id}`;
    return axiosApi.get(url);
  },
};

export default communityApi;
